import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getProposalView, getListProposal, bid_shortlist, award_bid, get_hired_freelancer, cancel_award, mark_complete_project, save_private_note, hide_bid, like_bid, AcceptAndRejectCounterOffer } from '../../Apis/index';

export const GetPropjectProposalView = createAsyncThunk('GetPropjectProposalView', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await getProposalView(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const GetProposalListing = createAsyncThunk('GetProposalListing', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await getListProposal(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const ShortilistBId = createAsyncThunk('ShortilistBId', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await bid_shortlist(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});
export const AwardFreelancer = createAsyncThunk('AwardFreelancer', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await award_bid(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});
export const GetHiredfreelancer = createAsyncThunk('GetHiredfreelancer', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await get_hired_freelancer(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const CancelFreelancerAward = createAsyncThunk('CancelFreelancerAward', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await cancel_award(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const CompleteProject = createAsyncThunk('CompleteProject', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await mark_complete_project(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const SavePrivateNote = createAsyncThunk('SavePrivateNote', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await save_private_note(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});
export const hideBid = createAsyncThunk('hideBid', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await hide_bid(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});


export const LikeBid = createAsyncThunk('LikeBid', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await like_bid(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

// export const acceptAndRejectCounterOffer =createAsyncThunk() async ({ formData, token }, { rejectWithValue }) => {
//     try {
//         const response = await AcceptAndRejectCounterOffer(formData, token);
//         return response
//     } catch (error) {
//         return rejectWithValue(error.response);
//     }
// }
export const acceptAndRejectCounterOffer = createAsyncThunk("acceptAndRejectCounterOffer", async ({ token, formData }, { rejectWithValue }) => {
    try {
        const response = await AcceptAndRejectCounterOffer(token, formData);
        console.log("show response from creaAsync or counter offer sttas--", response);

        return response
    } catch (error) {
        return rejectWithValue(error.response)
    }
})

const proposalSlice = createSlice({
    name: 'proposal',
    initialState: {
        error: null,
        success: false,
        error1: null,
        success1: false,
        data: {},
        data1: [],
        CounterOffer: {},
        hired: {},
        workspaceId: null
    },
    reducers: {
        clearproposalStatus: state => {
            state.success = false;
            state.error = null;
            state.success1 = false;
            state.error1 = null;
        },

        EmptyClientTab: state => {
            state.data1 = [];
        },

        setWorkId: (state, action) => {
            state.workspaceId = action.payload;
        }


    },
    extraReducers: builder => {
        builder
            .addCase(GetPropjectProposalView.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(GetPropjectProposalView.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload.data.data;
            })
            .addCase(GetPropjectProposalView.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(GetProposalListing.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(GetProposalListing.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data1 = action.payload.data.data;
            })
            .addCase(GetProposalListing.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(ShortilistBId.pending, state => {
                state.error1 = null;
                state.success1 = false;
            })
            .addCase(ShortilistBId.fulfilled, (state, action) => {
                state.success1 = action.payload;
                state.error1 = null;
            })
            .addCase(ShortilistBId.rejected, (state, action) => {
                state.error1 = action.payload;
                state.success1 = false;
            })
            .addCase(AwardFreelancer.pending, state => {
                state.error1 = null;
                state.success1 = false;
            })
            .addCase(AwardFreelancer.fulfilled, (state, action) => {
                state.success1 = action.payload;
                state.error1 = null;
            })
            .addCase(AwardFreelancer.rejected, (state, action) => {
                state.error1 = action.payload;
                state.success1 = false;
            })
            .addCase(GetHiredfreelancer.pending, state => {
                state.error1 = null;
                state.success1 = false;
            })
            .addCase(GetHiredfreelancer.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.hired = action.payload.data.data;
            })
            .addCase(GetHiredfreelancer.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(CancelFreelancerAward.pending, state => {
                state.error1 = null;
                state.success1 = false;
            })
            .addCase(CancelFreelancerAward.fulfilled, (state, action) => {
                state.success1 = action.payload;
                state.error1 = null;
            })
            .addCase(CancelFreelancerAward.rejected, (state, action) => {
                state.error1 = action.payload;
                state.success1 = false;
            })
            .addCase(CompleteProject.pending, state => {
                state.error1 = null;
                state.success1 = false;
            })
            .addCase(CompleteProject.fulfilled, (state, action) => {
                state.success1 = action.payload;
                state.error1 = null;
            })
            .addCase(CompleteProject.rejected, (state, action) => {
                state.error1 = action.payload;
                state.success1 = false;
            })

            .addCase(SavePrivateNote.pending, state => {
                state.error1 = null;
                state.success1 = false;
            })
            .addCase(SavePrivateNote.fulfilled, (state, action) => {
                state.success1 = action.payload;
                state.error1 = null;
            })
            .addCase(SavePrivateNote.rejected, (state, action) => {
                state.error1 = action.payload;
                state.success1 = false;
            })

            .addCase(hideBid.pending, state => {
                state.error1 = null;
                state.success1 = false;
            })
            .addCase(hideBid.fulfilled, (state, action) => {
                state.success1 = action.payload;
                state.error1 = null;
            })
            .addCase(hideBid.rejected, (state, action) => {
                state.error1 = action.payload;
                state.success1 = false;
            })
            .addCase(LikeBid.pending, state => {
                state.error1 = null;
                state.success1 = false;
            })
            .addCase(LikeBid.fulfilled, (state, action) => {
                state.success1 = action.payload;
                state.error1 = null;
            })
            .addCase(LikeBid.rejected, (state, action) => {
                state.error1 = action.payload;
                state.success1 = false;
            })
            .addCase(acceptAndRejectCounterOffer.pending, state => {
                state.error1 = null;
                state.success1 = false;

            })
            .addCase(acceptAndRejectCounterOffer.fulfilled, (state, action) => {
                state.success1 = action.payload;
                state.error1 = null;
                state.CounterOffer = action.payload
                // console.log("show fulfilles success in addcase-->", state.success1);


            })
            .addCase(acceptAndRejectCounterOffer.rejected, (state, action) => {
                state.error1 = action.payload;
                state.success1 = false
            })


    },

});
export const { clearproposalStatus, EmptyClientTab, setWorkId } = proposalSlice.actions;
export default proposalSlice.reducer;

